export default {
  TARGET_ACTIVATION: {
    TITLE_EMAIL_HINT: "Ce titre sera affiché aux utilisateurs dans l’e-mail d’invitation.",
    EDIT: 'Modifier le ciblage',
    NAME: 'Nom du ciblage',
    START: 'Date et heure de début',
    END: 'Date et heure de fin',
    SHARE: 'Partager le lien',
    CLOSE: 'Clôturer le ciblage',
    STATUS: 'Statut',
    STATUS_SCHEDULED: 'À venir',
    STATUS_ACTIVE: 'En cours',
    STATUS_ENDED: 'Terminé',
    STATUS_CLOSED: 'Clôturé',
    STATUS_UNKNOWN: 'Statut indisponible',
    PARTICIPATION: 'Participation',
    RESPONSES_RECEIVED: 'Réponses reçues',
    TARGETED_COUNT: '{{count}} personnes ciblées',
    TARGETED_ONE: '1 personne ciblée',
    PARTICIPATION_SUMMARY: '{{received}} réponses reçues pour {{targeted}} personnes ciblées.',
    PARTICIPATION_HINT: 'Le taux est estimé à partir des soumissions reçues et de la population actuellement ciblée. Les réponses anonymes ou les changements de population peuvent modifier ce ratio. Sans population ciblée, le taux est indisponible.',
    NAME_REQUIRED: 'Renseignez un nom de ciblage de 1 à 255 caractères.',
    DATES_INVALID: 'Renseignez des dates valides, avec une fin strictement postérieure au début.',
    PERIOD_HINT: 'Modifier les dates change la période d’accès. Prolonger un ciblage expiré peut le rendre à nouveau accessible.',
    CLOSED_HINT: 'Un ciblage clôturé manuellement restera clôturé après cette modification.',
    UPDATE_SUCCESS: 'Le ciblage a été mis à jour.',
    UPDATE_ERROR: 'Impossible de mettre à jour le ciblage. Veuillez réessayer.',
    ERROR_FORBIDDEN: 'Vous ne disposez pas des droits pour modifier ce ciblage.',
    ERROR_NOT_FOUND: 'Ce ciblage est introuvable ou n’est plus disponible.',
    ERROR_NOT_EDITABLE: 'Ce ciblage est géré par le module onboarding et ne peut pas être modifié ici.',
  },
  RESULTS: {
    TITLE: 'Résultats',
    DISPLAY_MODES: {
      PERCENTAGE: 'Pourcentage',
      NUMBERS: 'Numérique',
      AVERAGE: 'Moyenne',
    },
    FILTERS: {
      TITLE: 'Filtrage',
      ALL: 'Tous',
      RESET: 'Réinitialiser',
      GENDER: 'Genre',
      CONTRACT_TYPE: 'Type de contrat',
      AGE_RANGE: "Tranche d'âge",
      SENIORITY: 'Ancienneté',
      // Label for the chart-specific multi-select displayed above the transverse-team chart.
      TRANSVERSE_TEAMS: 'Équipes transverses',
      // Compact summaries match the wording and density of the existing select filters.
      ALL_TRANSVERSE_TEAMS: 'Tous',
      NO_TRANSVERSE_TEAM: 'Aucune',
      TRANSVERSE_TEAMS_COUNT: '{{count}} équipes',
      GENDER_MALE: 'Homme',
      GENDER_FEMALE: 'Femme',
      GENDER_OTHER: 'Autre',
      UNKNOWN_OPTION: 'Inconnu / Non renseigné',
      UNKNOWN_HINT: 'Les valeurs inconnues sont disponibles sous « Inconnu / Non renseigné ».',
      HIDE_SMALL_TEAMS: 'Masquer les équipes < 5 réponses',
      HIDE_SMALL_TEAMS_HINT: 'Masque les équipes ayant moins de 5 réponses',
    },
    CHARTS: {
      BY_SITE: 'Répartition par site',
      BY_SERVICE: 'Répartition par service',
      BY_TEAM: 'Répartition par équipe',
      BY_TRANSVERSE_TEAM: 'Répartition par équipe transverse',
      AVERAGE: 'Moyenne',
    },
    AI_VISUAL: {
      BUTTON: 'Générer un visuel IA',
      TITLE: 'Génération de visuel IA',
      PROMPT_LABEL: 'Décrivez le visuel souhaité',
      PROMPT_PLACEHOLDER: 'Exemple : Crée un résumé A4 clair avec les indicateurs clés, les principaux risques et les actions prioritaires.',
      SCOPE_LABEL: 'Périmètre des données',
      SCOPE_CURRENT_FILTERS: 'Filtres actuels',
      SCOPE_FULL_TARGET: 'Ciblage complet',
      REFERENCE_IMAGE: 'Image de style ou référence (optionnel)',
      ANALYZE_REFERENCE: 'Analyser',
      REFERENCE_ANALYSIS_TITLE: 'Ce que l’IA comprend de l’image',
      ANALYZING_REFERENCE: 'Analyse de l’image...',
      REFERENCE_ANALYSIS_SUMMARY: 'Résumé',
      REFERENCE_ANALYSIS_MOTIF: 'Structure',
      REFERENCE_ANALYSIS_SHAPE: 'Forme',
      REFERENCE_ANALYSIS_PRIMARY_VISUAL: 'Visuel principal',
      REFERENCE_ANALYSIS_COMPOSITION: 'Composition',
      REFERENCE_ANALYSIS_STYLE: 'Style',
      REFERENCE_ANALYSIS_CONFIDENCE: 'Confiance',
      REFERENCE_ANALYSIS_CUES: 'Détails visuels détectés',
      REFERENCE_ANALYSIS_ERROR: 'Impossible d’analyser l’image de référence.',
      CLEAR_FILE: 'Retirer',
      HISTORY: 'Historique',
      HIDE_HISTORY: 'Masquer historique',
      SHOW_HISTORY: 'Afficher historique',
      REFRESH: 'Actualiser',
      NO_HISTORY: 'Aucun visuel généré pour ce ciblage.',
      STATUS_PROCESSING: 'Génération en cours',
      STATUS_READY: 'Prêt',
      STATUS_FAILED: 'Échec',
      STATUS_STALE: 'À relancer',
      PREVIEW: 'Aperçu',
      EMPTY_PREVIEW: 'Sélectionnez ou générez un visuel pour afficher l’aperçu.',
      GENERATING: 'Génération du visuel en cours...',
      GENERATE: 'Générer',
      RETRY: 'Relancer',
      DOWNLOAD_PNG: 'Télécharger PNG',
      DOWNLOAD_PDF: 'Télécharger PDF',
      ERROR_REQUIRED_PROMPT: 'Veuillez décrire le visuel souhaité.',
      ERROR_MISSING_TARGET: 'Le ciblage de l’enquête est introuvable.',
      ERROR_UNSUPPORTED_FILE: 'Format non pris en charge. Utilisez PNG, JPG ou WebP.',
      ERROR_QUOTA: 'Crédits IA insuffisants.',
      ERROR_GENERIC: 'Une erreur est survenue lors de la génération du visuel.',
    },
    AI_CHAT: {
      BUTTON: 'Discuter avec Kai',
      TITLE: 'Kai, assistant d’enquête',
      RESPONSES: 'réponses',
      QUESTIONS: 'questions',
      HISTORY: 'Historique',
      NEW_CHAT: 'Nouveau chat',
      MINIMIZE: 'Réduire',
      RESTORE: 'Restaurer le chat',
      RUNNING_COMPACT_STATUS: 'Le traitement continue en arrière-plan...',
      FAILED_COMPACT_STATUS: 'L’analyse du document nécessite votre attention',
      VISUAL_FAILED_COMPACT_STATUS: 'La génération du visuel nécessite votre attention',
      REPORT_FAILED_COMPACT_STATUS: 'La génération du rapport nécessite votre attention',
      IDLE_COMPACT_STATUS: 'Chat prêt',
      LEAVE_WARNING: 'Une opération est toujours en cours. Quitter maintenant peut l’interrompre. Voulez-vous quitter ?',
      NEW_CONVERSATION: 'Nouvelle conversation',
      NO_HISTORY: 'Aucune conversation pour ce ciblage.',
      LOADING: 'Chargement...',
      WELCOME_TEXT: 'Bonjour, je peux analyser ces résultats ou créer un visuel à partir des données vérifiées de l’enquête.',
      WELCOME_HTML: '<p>Bonjour, je peux analyser ces résultats ou créer un visuel à partir des données vérifiées de l’enquête.</p><p><strong>{{responses}}</strong> réponses et <strong>{{questions}}</strong> questions sont disponibles dans le périmètre actuel.</p>',
      PLACEHOLDER: 'Posez une question ou demandez un visuel...',
      SEND: 'Envoyer',
      FOOTER_HINT: 'Entrée pour envoyer · Maj+Entrée pour un saut de ligne',
      REFERENCE_IMAGE: 'Image de référence',
      REFERENCE_DOCUMENT: 'Document de référence',
      ADD_REFERENCE: 'Ajouter une image ou un document de référence',
      PASTE_HINT: 'Ctrl+V pour coller une image · PDF et PowerPoint acceptés',
      REFERENCE_DEFAULT_PROMPT: 'Utilise cette image comme modèle visuel strict d’une page unique à adapter fidèlement, et non comme une simple inspiration. Reproduis son format, son rapport largeur/hauteur, sa composition, ses proportions, sa hiérarchie, son mécanisme visuel principal, sa légende, ses annotations et ses codes couleur. Remplace uniquement les contenus sources par les données vérifiées de l’enquête. Ne crée aucune section supplémentaire, ne change pas de type de visualisation et ne transforme pas la mise en page en interface responsive.',
      DOCUMENT_REFERENCE_DEFAULT_PROMPT: 'Générer un rapport à partir de ce document.',
      CLEAR_REFERENCE: 'Retirer',
      CLEAR_REFERENCE_ERROR: 'Impossible de retirer l’image de référence. Veuillez réessayer.',
      ANALYZING_REFERENCE: 'Analyse de la référence...',
      REFERENCE_READY: 'Référence active pour cette conversation',
      REFERENCE_PAGE_PROGRESS: '{{analyzed}}/{{total}} pages analysées',
      REFERENCE_AUTOMATIC_RECOVERY: 'Récupération automatique de {{count}} page(s) · {{current}}/{{total}}',
      REFERENCE_DOCUMENT_ANALYSIS_TITLE: 'Analyse du document',
      REFERENCE_IMAGE_ANALYSIS_TITLE: 'Analyse de l’image',
      REFERENCE_DOCUMENT_READY_TITLE: 'Document analysé',
      REFERENCE_IMAGE_READY_TITLE: 'Image analysée',
      REFERENCE_DOCUMENT_FAILED_TITLE: 'Analyse du document incomplète',
      REFERENCE_IMAGE_FAILED_TITLE: 'Analyse de l’image incomplète',
      REFERENCE_IMAGE_TYPE: 'Image',
      REFERENCE_FILE_META_PAGES: '{{type}} · {{pages}} pages',
      REFERENCE_PREPARING_DOCUMENT: 'Préparation du document pour l’analyse',
      REFERENCE_SCANNING_IMAGE: 'Détection de la composition, des couleurs et des régions visuelles',
      REFERENCE_ANALYSIS_STEPS: 'Étapes d’analyse de la référence',
      REFERENCE_STEP_IMPORT: 'Import',
      REFERENCE_STEP_PAGES: 'Pages',
      REFERENCE_STEP_SYNTHESIS: 'Synthèse',
      REFERENCE_STEP_FINALIZATION: 'Finalisation',
      REFERENCE_CONTINUES_BACKGROUND: 'L’analyse continue en arrière-plan si vous réduisez Kai.',
      REFERENCE_DOCUMENT_READY_DETAIL: 'Référence prête · {{pages}} pages analysées',
      REFERENCE_IMAGE_READY_DETAIL: 'Composition, couleurs et relations visuelles prêtes',
      REFERENCE_ANALYSIS_FAILED: 'L’analyse du document a été interrompue',
      IMAGE_REFERENCE_ANALYSIS_FAILED: 'L’analyse de l’image a été interrompue',
      RETRY_REFERENCE_ANALYSIS: 'Réessayer les pages restantes',
      CHECK_REFERENCE_ANALYSIS: 'Vérifier l’état de l’analyse',
      REFERENCE_TRACKING_AUTOMATIC: 'La progression est actualisée automatiquement.',
      REFERENCE_TRACKING_INTERRUPTED: 'Le suivi automatique a été interrompu. L’analyse peut toujours être en cours.',
      RESUME_REFERENCE_TRACKING: 'Reprendre le suivi',
      REFERENCE_ANALYSIS_FAILED_DETAIL: 'Pages non analysées : {{count}}. Les pages déjà analysées sont conservées.',
      RETRY_FAILED_REFERENCE_PAGES: 'Réessayer les pages échouées ({{count}})',
      RETRY_IMAGE_REFERENCE_ANALYSIS: 'Réessayer l’analyse de l’image',
      REPORT_GENERATION_RUNNING: 'Génération des pages du rapport...',
      REPORT_CREATION_TITLE: 'Création de votre rapport',
      REPORT_PLANNING_SUBTITLE: 'Organisation des sections et des pages',
      REPORT_CURRENT_PAGE: 'Génération de la page {{page}}',
      REPORT_PREPARING_PAGES: 'Préparation des pages du rapport',
      REPORT_FINALIZING: 'Finalisation du rapport',
      REPORT_CONTINUES_BACKGROUND: 'Le traitement continue en arrière-plan si vous réduisez cette fenêtre.',
      REPORT_MINIMIZED_PROGRESS: 'Rapport · {{ready}}/{{total}} pages · {{percent}} %',
      REPORT_MINIMIZED_PLANNING: 'Rapport · Planification',
      REPORT_MINIMIZED_RECOVERY: 'Rapport · Récupération de {{count}} page(s)',
      REPORT_RECOVERING_PAGES: 'Pages en cours de récupération : {{count}}',
      REPORT_RECOVERY_CYCLE: 'Récupération automatique {{current}}/{{total}}',
      REPORT_PAGE_STATES: 'État des pages du rapport',
      REPORT_PAGE_STATE_READY: 'Page {{page}}, terminée',
      REPORT_PAGE_STATE_FAILED: 'Page {{page}}, incomplète',
      REPORT_PAGE_STATE_CURRENT: 'Page {{page}}, en cours de génération',
      REPORT_PAGE_STATE_PENDING: 'Page {{page}}, en attente',
      REPORT_PHASES: 'Étapes de génération du rapport',
      REPORT_PHASE_PLANNING: 'Planification',
      REPORT_PHASE_STRUCTURE: 'Structure',
      REPORT_PHASE_PAGES: 'Pages',
      REPORT_PHASE_FINALIZATION: 'Finalisation',
      VISUAL_GENERATION_RUNNING: 'Création de votre visuel',
      VISUAL_CREATION_RUNNING: 'Création de votre visuel',
      VISUAL_OPTIMIZATION_RUNNING: 'Optimisation de votre visuel',
      VISUAL_PROGRESS_CANDIDATE: 'Version {{current}} sur {{total}}',
      VISUAL_PROGRESS_ADJUSTMENT: 'Ajustement {{current}} sur {{total}}',
      VISUAL_PROGRESS_STEPS: 'Étapes de création du visuel',
      VISUAL_STEP_ANALYSIS: 'Analyse',
      VISUAL_STEP_CREATION: 'Création',
      VISUAL_STEP_VALIDATION: 'Vérification',
      VISUAL_STEP_FINALIZATION: 'Finalisation',
      VISUAL_CONTINUES_BACKGROUND: 'Le traitement continue en arrière-plan si vous réduisez cette fenêtre.',
      VISUAL_PROGRESS_QUEUED: 'Mise en file d’attente',
      VISUAL_PROGRESS_PREPARING_EVIDENCE: 'Préparation des données vérifiées',
      VISUAL_PROGRESS_PLANNING_VISUAL: 'Planification de la composition',
      VISUAL_PROGRESS_GENERATING_CANDIDATE: 'Création de la composition',
      VISUAL_PROGRESS_VALIDATING_CANDIDATE: 'Vérification des données et de la mise en page',
      VISUAL_PROGRESS_CORRECTING_CANDIDATE: 'Affinage de la composition',
      VISUAL_PROGRESS_FINAL_BROWSER_VALIDATION: 'Vérification du canevas final',
      VISUAL_PROGRESS_RENDERING_PNG: 'Rendu de l’image',
      VISUAL_PROGRESS_EXTRACTING_SCENE: 'Préparation des éléments modifiables',
      VISUAL_PROGRESS_SAVING_RESULT: 'Enregistrement du résultat',
      REPORT_PLANNING: 'Préparation du plan du rapport...',
      REPORT_LIVE_FAILED_PAGE_COUNT: 'Pages nécessitant actuellement une nouvelle tentative : {{count}}',
      REPORT_GENERATION_PARTIAL: 'Le rapport est incomplet. Les pages validées ont été conservées.',
      REPORT_PAGE_PROGRESS: '{{ready}}/{{total}} pages prêtes',
      REPORT_FAILED_PAGE_COUNT: 'Pages nécessitant une nouvelle tentative : {{count}}',
      RETRY_FAILED_REPORT_PAGES: 'Réessayer les pages incomplètes',
      RETRY_VISUAL_GENERATION: 'Réessayer la génération du visuel',
      VISUAL_PREVIEW: 'Aperçu du visuel',
      EXPAND_PREVIEW: 'Agrandir',
      EXPORT_PNG: 'Exporter PNG',
      EXPORT_PPTX: 'PowerPoint',
      EXPORT_REPORT_PPTX: 'Exporter le rapport complet en PowerPoint',
      EXPORT_PDF: 'Exporter PDF',
      EXPORTING: 'Export en cours...',
      OPEN_PNG: 'Ouvrir PNG',
      OPEN_PDF: 'Ouvrir PDF',
      ERROR_LOAD_HISTORY: 'Impossible de charger l’historique.',
      ERROR_CREATE_CONVERSATION: 'Impossible de créer la conversation.',
      ERROR_LOAD_MESSAGES: 'Impossible de charger les messages.',
      ERROR_UNSUPPORTED_IMAGE: 'Format non pris en charge. Utilisez PNG, JPG ou WebP.',
      ERROR_UNSUPPORTED_REFERENCE: 'Format non pris en charge. Utilisez PNG, JPG, WebP, PDF ou PPTX.',
      ERROR_IMAGE_TOO_LARGE: 'L’image dépasse la taille maximale de 5 Mo.',
      ERROR_DOCUMENT_TOO_LARGE: 'Le document dépasse la taille maximale de 20 Mo.',
      ERROR_ANALYZE_IMAGE: 'Impossible d’analyser l’image de référence.',
      ERROR_ANALYZE_REFERENCE: 'Impossible d’analyser le fichier de référence.',
      ERROR_DOCUMENT_ANALYSIS_IN_PROGRESS: 'Un autre document est déjà en cours d’analyse. Restaurez l’analyse Kai actuellement réduite et attendez qu’elle se termine.',
      ERROR_DOCUMENT_ANALYSIS_PARTIAL: 'L’analyse du document a été interrompue. Les pages réussies ont été conservées ; relancez pour analyser uniquement les pages restantes.',
      ERROR_QUOTA: 'Crédits IA insuffisants.',
      ERROR_REPORT_GENERATION: 'Le rapport n’a pas pu être généré. Aucun rapport n’a été enregistré et aucun crédit IA n’a été débité.',
      ERROR_VISUAL_GENERATION: 'Le visuel n’a pas pu être généré. Aucun visuel n’a été enregistré et aucun crédit IA n’a été débité.',
      ERROR_SEND: 'Impossible d’envoyer le message.',
      ERROR_EXPORT: 'Impossible d’exporter le visuel.',
      ERROR_REPORT_EXPORT: 'Impossible d’exporter le rapport complet en PowerPoint.',
      ERROR_REPORT_EXPORT_TOO_LARGE: 'Le rapport est trop volumineux pour être exporté en PowerPoint.',
      ERROR_REPORT_EXPORT_BUSY: 'L’export PowerPoint est occupé. Veuillez réessayer dans quelques instants.',
      ERROR_REPORT_EXPORT_REGENERATE: 'Régénérez les visuels du rapport avant d’exporter le PowerPoint.',
      ERROR_PPTX_REGENERATE: 'Régénérez ce visuel avant de l’exporter dans PowerPoint.',
      ERROR_PPTX_TOO_LARGE: 'Ce visuel est trop volumineux pour être exporté dans PowerPoint.',
      ERROR_PPTX_BUSY: 'L’export PowerPoint est occupé. Veuillez réessayer dans quelques instants.',
      DELETE_HISTORY_TITLE: 'Supprimer cette conversation ?',
      DELETE_HISTORY_WARNING: 'Cette action supprimera définitivement la conversation, tous ses messages, ses visuels et tous les fichiers exportés associés. Cette action est irréversible.',
      DELETE_HISTORY_SUCCESS: 'La conversation et ses fichiers ont été supprimés.',
      DELETE_HISTORY_ERROR: 'Impossible de supprimer la conversation et ses fichiers.',
    },
  },
}
